module.exports = __webpack_public_path__ + "static/img/pro9_tab3.907b6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab3.jpg
// module id = 5oHE
// module chunks = 171